import { save, load } from './storage';
import type { GeneratedCV } from '@/services/cv.service';

const CVS_KEY = 'cvs';

export const localCVService = {
  async list(): Promise<GeneratedCV[]> {
    return load<GeneratedCV[]>(CVS_KEY, []);
  },

  async save(cv: GeneratedCV): Promise<GeneratedCV> {
    const existing = load<GeneratedCV[]>(CVS_KEY, []);
    const filtered = existing.filter((item) => item.id !== cv.id);
    const updated = [...filtered, cv];
    save(CVS_KEY, updated);
    return cv;
  },

  async remove(id: string): Promise<void> {
    const existing = load<GeneratedCV[]>(CVS_KEY, []);
    save(
      CVS_KEY,
      existing.filter((item) => item.id !== id)
    );
  },

  async get(id: string): Promise<GeneratedCV | undefined> {
    const existing = load<GeneratedCV[]>(CVS_KEY, []);
    return existing.find((item) => item.id === id);
  },
};












